module.exports = __webpack_public_path__ + "img/login-img.df7d9a52.png";